// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"0c6874be","332":"a5475546","477":"4d610741","522":"5b0d1b79","698":"81919e68","740":"7fdc4e5c","900":"9bd22225"}[chunkId] + ".chunk.js";
};